import axios from 'axios'
import http from 'http'
import https from 'https'
import store from '@/store'

const HTTPClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeOut: 10000,
  maxSockets: 50,
  freeSocketTimeout: 225000,
  httpAgent: new http.Agent({ keepAlive: true }),
  httpsAgent: new https.Agent({ keepAlive: true })
})

const HTTPGatewayClient = axios.create({
  baseURL: process.env.VUE_APP_API_GW_BASE_URL,
  timeOut: 10000,
  maxSockets: 50,
  freeSocketTimeout: 225000,
  httpAgent: new http.Agent({ keepAlive: true }),
  httpsAgent: new https.Agent({ keepAlive: true })
})

const HTTPGatewayFileClient = axios.create({
  baseURL: process.env.VUE_APP_API_GW_BASE_URL,
  timeOut: 10000,
  maxSockets: 50,
  freeSocketTimeout: 225000,
  httpAgent: new http.Agent({ keepAlive: true }),
  httpsAgent: new https.Agent({ keepAlive: true })
})

const HTTPGatewayFileBlobClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_GW_BASE_URL}/attachments`,
  timeOut: 10000,
  maxSockets: 50,
  freeSocketTimeout: 225000,
  httpAgent: new http.Agent({ keepAlive: true }),
  httpsAgent: new https.Agent({ keepAlive: true })
})

const HTTPKeyCloakClient = axios.create({
  baseURL: process.env.VUE_APP_API_GW_BASE_URL,
  timeOut: 10000,
  maxSockets: 50,
  freeSocketTimeout: 225000,
  httpAgent: new http.Agent({ keepAlive: true }),
  httpsAgent: new https.Agent({ keepAlive: true })
})

const HTTPFileClient = axios.create({
  baseURL: process.env.VUE_APP_API_FILE_SERVICE_URL,
  timeOut: 10000,
  maxSockets: 50,
  freeSocketTimeout: 225000,
  httpAgent: new http.Agent({ keepAlive: true }),
  httpsAgent: new https.Agent({ keepAlive: true })
})

HTTPClient.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${store.state.oidcStore.access_token}`
    }
    return config
  },
  async (err) => Promise.reject(err)
)

HTTPGatewayClient.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      Accept: 'application/json',
      Authorization: `Bearer ${store.state.oidcStore.access_token}`
    }
    return config
  },
  async (err) => Promise.reject(err)
)

HTTPGatewayFileClient.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${store.state.oidcStore.access_token}`
    }
    return config
  },
  async (err) => Promise.reject(err)
)

HTTPGatewayFileBlobClient.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${store.state.oidcStore.access_token}`
    }
    config.responseType = 'blob'
    return config
  },
  async (err) => Promise.reject(err)
)

HTTPFileClient.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${store.state.oidcStore.access_token}`
    }
    return config
  },
  async (err) => Promise.reject(err)
)

HTTPKeyCloakClient.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${store.state.oidcStore.access_token}`
    }
    return config
  },
  async (err) => Promise.reject(err)
)

export {
  HTTPClient,
  HTTPFileClient,
  HTTPGatewayClient,
  HTTPGatewayFileClient,
  HTTPGatewayFileBlobClient,
  HTTPKeyCloakClient
}
